import { Dialog } from "primereact/dialog";
import React, { useState, useEffect } from "react";
import { IPrimeVendorAllocation } from "./Table";
import { JVDropdown } from "../../shared/JVDropdown";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { MultiSelect } from "primereact/multiselect";
import { ILogin } from "../../models/Login";
import { ICompanyMastDropdown } from "../../models/IDropdown";
import { Fetch } from "../../shared/Fetch";
import { Button } from "primereact/button";

interface IProps {
  singleData: IPrimeVendorAllocation;
  open: boolean;
  hideDialog: () => void;
  toast: any;
  reload: boolean;
  setReload: (is: boolean) => void;
}

const schema = yup.object({
  from_Company_ID: yup.number().min(1, "Requirement From Company is required").required("Requirement From Company is required").typeError("Req From Company is required"),
});

const Form = (props: IProps) => {
  const [selectedCompany, setSelectedCompany] = useState<Array<number>>([]);
  const [companyList, setCompanyList] = useState<Array<ICompanyMastDropdown>>([]);
  const [saving, setSaving] = useState(false);
  const [multiSelectError, setMultiSelectError] = useState<string>("");
  const isEdit = props.singleData.id > 0;

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<IPrimeVendorAllocation>({
    resolver: yupResolver(schema),
    defaultValues: props.singleData,
    shouldFocusError: false,
  });

  const loadCompanies = async () => {
    const response = await Fetch("Dropdown/company", "GET", null, null, null);
    if (response) {
      const data: Array<ICompanyMastDropdown> = await response.json();
      setCompanyList(data);
    }
  };

  useEffect(() => {
    loadCompanies();
    reset(props.singleData);
    setSelectedCompany([]);
  }, [props.singleData]);

  const onHide = () => {
    reset();
    setSelectedCompany([]);
    setMultiSelectError("");
    props.hideDialog();
  };

  const _roles: Array<number> = [];
  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  loginObj.roles.forEach((role) => _roles.push(role.role_ID));
  const isAuthorized = _roles.includes(1) || _roles.includes(26);

  const onSubmit = async (data: IPrimeVendorAllocation) => {
    try {
      if (!isEdit && selectedCompany.length === 0) {
        setMultiSelectError("Allocate To Companies is required");
        return;
      }
      setMultiSelectError("");
      setSaving(true);

      if (isEdit) {
        const res = await Fetch("PV_Allocation_Mast/updatefromcompany", "PUT", { ID: props.singleData.id, From_Company_ID: data.from_Company_ID }, "", props.toast);
        if (res && res.ok) {
          props.toast.current?.show({ severity: "success", summary: "Updated", life: 2000 });
          props.setReload(!props.reload);
          onHide();
        }
      } else {
        const res = await Fetch("PV_Allocation_Mast/savepvallocation", "POST", { From_Company_ID: data.from_Company_ID, Company_IDs: selectedCompany }, "", props.toast);
        if (res && res.ok) {
          props.toast.current?.show({ severity: "success", summary: "Saved", life: 2000 });
          props.setReload(!props.reload);
          onHide();
        }
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog visible={props.open} style={{ width: "60vw" }} header={isEdit ? "Edit Req From Company" : "Add Prime Vendor Allocation"} modal className="p-fluid" onHide={onHide}>
      <form onSubmit={handleSubmit(onSubmit)} className="p-fluid grid">
        {isAuthorized && (
          <div className="field col-12 md:col-6">
            <label className="block mb-2 font-medium">Req From Company</label>
            <JVDropdown required label="Company" control={control} name="from_Company_ID" error={errors.from_Company_ID?.message} options={companyList} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" />
          </div>
        )}

        {isAuthorized && !isEdit && (
          <div className="field col-12 md:col-4 mt-6 mr-4">
            <label className="block mb-2 font-medium">Allocate To Companies</label>
            <MultiSelect
              required
              value={selectedCompany}
              onChange={(e) => {
                setSelectedCompany(e.value);
                if (e.value.length > 0) setMultiSelectError("");
              }}
              options={companyList}
              optionValue="company_ID"
              optionLabel="company_Name"
              display="chip"
              filter
              placeholder="Select Companies"
              className="w-full"
            />
            {multiSelectError && <small className="p-error">{multiSelectError}</small>}
          </div>
        )}

        <div className="col-12 flex gap-3 mt-4">
          <Button label="SAVE" type="submit" className="flex-1" loading={saving} disabled={saving} />
          <Button label="CLOSE" type="button" onClick={onHide} className="p-button-outlined flex-1" />
        </div>
      </form>
    </Dialog>
  );
};

export default Form;
